module.exports = __webpack_public_path__ + "static/media/ti1.e4815eea.jpg";